export default {
  install(Vue) {
    Vue.directive('visible', function(el, binding) {
    el.style.visibility = !!binding.value ? 'visible' : 'hidden';
    });
  },
}
